import _defineProperty2 from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _defaultNodeResolvers, _defaultMarkResolvers;

import "core-js/modules/es.array.reduce-right.js";
import React from 'react';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["component"];
var NODE_HEADING = 'heading';
var NODE_CODEBLOCK = 'code_block';
var NODE_PARAGRAPH = 'paragraph';
var NODE_QUOTE = 'blockquote';
var NODE_OL = 'ordered_list';
var NODE_UL = 'bullet_list';
var NODE_LI = 'list_item';
var NODE_HR = 'horizontal_rule';
var NODE_BR = 'hard_break';
var NODE_IMAGE = 'image';
var MARK_BOLD = 'bold';
var MARK_ITALIC = 'italic';
var MARK_STRIKE = 'strike';
var MARK_UNDERLINE = 'underline';
var MARK_CODE = 'code';
var MARK_LINK = 'link';
var MARK_STYLED = 'styled';

function render(document) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof document === 'object' && document.type === 'doc' && Array.isArray(document.content)) {
    var _options$blokResolver = options.blokResolvers,
        blokResolvers = _options$blokResolver === void 0 ? {} : _options$blokResolver,
        _options$defaultBlokR = options.defaultBlokResolver,
        defaultBlokResolver = _options$defaultBlokR === void 0 ? function () {
      return null;
    } : _options$defaultBlokR,
        _options$nodeResolver = options.nodeResolvers,
        customNodeResolvers = _options$nodeResolver === void 0 ? {} : _options$nodeResolver,
        _options$markResolver = options.markResolvers,
        customMarkResolvers = _options$markResolver === void 0 ? {} : _options$markResolver,
        _options$textResolver = options.textResolver,
        textResolver = _options$textResolver === void 0 ? function (str) {
      return str;
    } : _options$textResolver;

    var nodeResolvers = _objectSpread2(_objectSpread2({}, defaultNodeResolvers), customNodeResolvers);

    var markResolvers = _objectSpread2(_objectSpread2({}, defaultMarkResolvers), customMarkResolvers);

    var currentKey = 0;

    var addKey = function addKey(element) {
      return React.isValidElement(element) ? React.cloneElement(element, {
        key: currentKey++
      }) : element;
    };

    var renderNodes = function renderNodes(nodes) {
      var elements = nodes ? nodes.map(renderNode).filter(function (node) {
        return node != null;
      }) : null;
      return Array.isArray(elements) && elements.length === 0 ? null : elements;
    };

    var renderNode = function renderNode(node) {
      if (node.type === 'blok') {
        var body = node.attrs.body;
        return body.map(function (_ref) {
          var component = _ref.component,
              props = _objectWithoutProperties(_ref, _excluded);

          var resolver = blokResolvers[component];
          var element = resolver ? resolver(props) : defaultBlokResolver(component, props);
          return addKey(element);
        });
      } else {
        var _node$marks;

        var childNode;

        if (node.type === 'text') {
          childNode = textResolver(node.text);
        } else {
          var resolver = nodeResolvers[node.type];
          childNode = resolver ? addKey(resolver(renderNodes(node.content), node.attrs)) : null;
        }

        var marks = (_node$marks = node.marks) !== null && _node$marks !== void 0 ? _node$marks : [];
        return marks.reduceRight(function (children, mark) {
          var resolver = markResolvers[mark.type];
          return resolver ? addKey(resolver(children, mark.attrs)) : children;
        }, childNode);
      }
    };

    return renderNodes(document.content);
  } else if (typeof document === 'string') {
    var _options$defaultStrin = options.defaultStringResolver,
        defaultStringResolver = _options$defaultStrin === void 0 ? function (str) {
      return str;
    } : _options$defaultStrin,
        _options$textResolver2 = options.textResolver,
        _textResolver = _options$textResolver2 === void 0 ? function (str) {
      return str;
    } : _options$textResolver2;

    return defaultStringResolver(_textResolver(document));
  }

  return null;
}

var simpleNodeResolver = function simpleNodeResolver(element) {
  return function (children) {
    return children != null ? React.createElement(element, null, children) : null;
  };
};

var emptyNodeResolver = function emptyNodeResolver(element) {
  return function () {
    return React.createElement(element);
  };
};

var headingNodeResolver = function headingNodeResolver(children, props) {
  return React.createElement("h".concat(props.level), null, children);
};

var imageNodeResolver = function imageNodeResolver(children, props) {
  return React.createElement('img', props, children);
};

var codeblockNodeResolver = function codeblockNodeResolver(children, props) {
  var codeProps = {
    className: props.class
  };
  var code = React.createElement('code', codeProps, children);
  return React.createElement('pre', null, code);
};

var simpleMarkResolver = function simpleMarkResolver(element) {
  return function (children) {
    return React.createElement(element, null, children);
  };
};

var linkMarkResolver = function linkMarkResolver(children, _ref2) {
  var linktype = _ref2.linktype,
      href = _ref2.href,
      target = _ref2.target;
  var props = {
    href: linktype === 'email' ? "mailto:".concat(href) : href,
    target: target
  };
  return React.createElement('a', props, children);
};

var styledMarkResolver = function styledMarkResolver(children, props) {
  return React.createElement('span', {
    className: props.class
  }, children);
};

var defaultNodeResolvers = (_defaultNodeResolvers = {}, _defineProperty2(_defaultNodeResolvers, NODE_HEADING, headingNodeResolver), _defineProperty2(_defaultNodeResolvers, NODE_CODEBLOCK, codeblockNodeResolver), _defineProperty2(_defaultNodeResolvers, NODE_IMAGE, imageNodeResolver), _defineProperty2(_defaultNodeResolvers, NODE_PARAGRAPH, simpleNodeResolver('p')), _defineProperty2(_defaultNodeResolvers, NODE_QUOTE, simpleNodeResolver('blockquote')), _defineProperty2(_defaultNodeResolvers, NODE_OL, simpleNodeResolver('ol')), _defineProperty2(_defaultNodeResolvers, NODE_UL, simpleNodeResolver('ul')), _defineProperty2(_defaultNodeResolvers, NODE_LI, simpleNodeResolver('li')), _defineProperty2(_defaultNodeResolvers, NODE_HR, emptyNodeResolver('hr')), _defineProperty2(_defaultNodeResolvers, NODE_BR, emptyNodeResolver('br')), _defaultNodeResolvers);
var defaultMarkResolvers = (_defaultMarkResolvers = {}, _defineProperty2(_defaultMarkResolvers, MARK_LINK, linkMarkResolver), _defineProperty2(_defaultMarkResolvers, MARK_STYLED, styledMarkResolver), _defineProperty2(_defaultMarkResolvers, MARK_BOLD, simpleMarkResolver('b')), _defineProperty2(_defaultMarkResolvers, MARK_ITALIC, simpleMarkResolver('i')), _defineProperty2(_defaultMarkResolvers, MARK_STRIKE, simpleMarkResolver('s')), _defineProperty2(_defaultMarkResolvers, MARK_UNDERLINE, simpleMarkResolver('u')), _defineProperty2(_defaultMarkResolvers, MARK_CODE, simpleMarkResolver('code')), _defaultMarkResolvers);
export { MARK_BOLD, MARK_CODE, MARK_ITALIC, MARK_LINK, MARK_STRIKE, MARK_STYLED, MARK_UNDERLINE, NODE_BR, NODE_CODEBLOCK, NODE_HEADING, NODE_HR, NODE_IMAGE, NODE_LI, NODE_OL, NODE_PARAGRAPH, NODE_QUOTE, NODE_UL, render };